export class OnBoardingDTO{
    image:any;
    text1:string = ''
    text2:string = ''
    text3:string = ''
}